import React, { useEffect, useState } from "react";
import app from "../firebase";
import { Editor } from "@tinymce/tinymce-react";
import apiClient from "../api.js";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const UpdateListing = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.user);
  const [propertyFiles, setPropertyFiles] = useState([]);
  // const [files, setFiles] = useState([]);
  const [reraFiles, setReraFiles] = useState([]);
  const [error, setError] = useState(false);
  const [rerauploading, setreraUploading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    imageUrls: [],
    reraimageURLS: [],
    reraName: "",
    name: "",
    description: "",
    address: "",
    price: null,
    possessiondate: "",
    aboutdevloper: "",
    devlopername: "",
    extraDetails: "",
    region: "",
    subregion: "",
    location: "",
    propertytype: "",
    discountedDeal: false,
    userRef: currentUser._id,
    BHK: [],
    sqftMin: [],
    sqftMax: [],
    priceRange: [],
    amenities: [],
  });
  const [imageUploadError, setImageUploadError] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [propertySpecs, setpropertySpecs] = useState({
    BHK: "",
    sqftMin: "",
    sqftMax: "",
    priceRange: "",
  });
  const params = useParams();

  useEffect(() => {
    const fetchProperties = async () => {
      const listingId = params.listingId;

      const res = await apiClient.get(`listing/get/${listingId}`);
      setFormData(res.data);
      // console.log(res.data);
      // Set regionMode based on location from database
      if (res.data.location === "pune") {
        setRegionMode("pune");
      } else {
        setRegionMode("mumbai");
      }

      if (res.data.propertytype === "residential") {
        setPropertyType("residential");
      } else if (res.data.propertytype === "commercial") {
        setPropertyType("commercial");
      }
      //   console.log(res);
    };

    fetchProperties();
  }, [params.listingId]);

  const handleImageSubmit = (e) => {
    if (
      propertyFiles.length > 0 &&
      propertyFiles.length + formData.imageUrls.length < 7
    ) {
      setUploading(true);
      setImageUploadError(false);
      const promises = [];
      for (let i = 0; i < propertyFiles.length; i++) {
        promises.push(storeImage(propertyFiles[i]));
      }

      Promise.all(promises)
        .then((urls) => {
          setFormData({
            ...formData,
            imageUrls: formData.imageUrls.concat(urls),
          });
          setImageUploadError(false);
          setUploading(false);
        })
        .catch((err) => {
          setImageUploadError("Image upload failed (2mb max per image)");
          setUploading(false);
        });
    } else {
      setImageUploadError("You can only upload 6 images per listing");
      setUploading(false);
    }
  };

  const handlereraImageSubmit = (e) => {
    if (
      reraFiles.length > 0 &&
      reraFiles.length + formData.reraimageURLS.length < 5
    ) {
      setreraUploading(true);
      setImageUploadError(false);
      const promises = [];
      for (let i = 0; i < reraFiles.length; i++) {
        promises.push(storeImage(reraFiles[i]));
      }

      Promise.all(promises)
        .then((urls) => {
          setFormData({
            ...formData,
            reraimageURLS: formData.reraimageURLS.concat(urls),
          });

          setImageUploadError(false);
          setreraUploading(false);
        })
        .catch((err) => {
          setImageUploadError("Image upload failed (1mb max per image)");
          setreraUploading(false);
        });
    } else {
      setImageUploadError("You can only upload 5 images per listing");
      setreraUploading(false);
    }
  };

  const storeImage = async (file) => {
    return new Promise((resolve, reject) => {
      const storage = getStorage(app);
      const fileName = new Date().getTime() + file.name;
      const storageRef = ref(storage, fileName);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is ${progress} done`);
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        },
      );
    });
  };

  const handleRemoveIamge = async (index) => {
    const storage = getStorage(app);
    const imageUrl = formData.imageUrls[index];
    const imageRef = ref(storage, imageUrl);

    try {
      await deleteObject(imageRef);
      console.log(`Image at index ${index} deleted successfully`);
      setFormData({
        ...formData,
        imageUrls: formData.imageUrls.filter((_, i) => i !== index),
      });
    } catch (error) {
      console.error("Error deleting image:", error);
    }

    setFormData({
      ...formData,
      imageUrls: formData.imageUrls.filter((_, i) => i !== index),
    });
  };

  const handleRemoveReraIamge = async (index) => {
    const storage = getStorage(app);
    const reraimageUrl = formData.reraimageURLS[index];
    const imageRef = ref(storage, reraimageUrl);

    try {
      await deleteObject(imageRef);

      setFormData({
        ...formData,
        reraimageURLS: formData.reraimageURLS.filter((_, i) => i !== index),
      });
    } catch (error) {
      console.error("Error deleting image:", error);
    }

    // setFormData({
    //   ...formData,
    //   reraimageURLS: formData.reraimageURLS.filter((_, i) => i !== index),
    // });
  };

  const handleChange = (e) => {
    if (e.target.id === "propertyName") {
      setFormData({
        ...formData,
        name: e.target.value,
      });
    }
    if (e.target.id === "propertyDesc") {
      setFormData({
        ...formData,
        description: e.target.value,
      });
    }
    if (e.target.id === "propertyAddress") {
      setFormData({
        ...formData,
        address: e.target.value,
      });
    }
    if (e.target.id === "propertyPrice") {
      setFormData({
        ...formData,
        price: e.target.value,
      });
    }

    if (e.target.id === "propertyPossessionDate") {
      setFormData({
        ...formData,
        possessiondate: e.target.value,
      });
    }
    if (e.target.id === "propertyDeveloperName") {
      setFormData({
        ...formData,
        devlopername: e.target.value,
      });
    }
    if (e.target.id === "propertyDeveloperDesc") {
      setFormData({
        ...formData,
        aboutdevloper: e.target.value,
      });
    }

    if (e.target.id === "regionName") {
      setFormData({
        ...formData,
        region: e.target.value,
      });
    }
    if (e.target.id === "subregionName") {
      setFormData({
        ...formData,
        subregion: e.target.value,
      });
    }
    if (e.target.id === "propertyReraName") {
      setFormData({
        ...formData,
        reraName: e.target.value,
      });
    }

    if (e.target.id === "falseDiscount") {
      // console.log(e.target.value);
      setFormData({
        ...formData,
        discountedDeal: e.target.value,
      });
    }
    if (e.target.id === "trueDiscount") {
      // console.log(e.target.value);
      setFormData({
        ...formData,
        discountedDeal: e.target.value,
      });
    }

    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      if (type === "checkbox") {
        // Ensure amenities is always an array before modifying
        const updatedAmenities = prevData.amenities
          ? [...prevData.amenities]
          : [];

        if (checked) {
          if (updatedAmenities.length < 8) {
            updatedAmenities.push(value); // Add checked amenity
          } else {
            alert("You can only select up to 8 amenities.");
            return prevData; // Return previous state if limit is reached
          } // Add checked amenity
        } else {
          const index = updatedAmenities.indexOf(value);
          if (index > -1) {
            updatedAmenities.splice(index, 1); // Remove unchecked amenity
          }
        }

        return { ...prevData, amenities: updatedAmenities };
      }

      return { ...prevData, [name]: value };
    });
  };

  // handle bhk sqft function

  const handlePropertySpecsChange = (e) => {
    const { name, value } = e.target;
    setpropertySpecs({
      ...propertySpecs,
      [name]: value,
    });
    // console.log(propertySpecs);
  };

  // handle sqft bhk onclick function

  const handleSubmitPropertySpecs = (e) => {
    e.preventDefault();
    // Validate if all inputs are filled
    if (
      propertySpecs.BHK &&
      propertySpecs.sqftMin &&
      propertySpecs.sqftMax &&
      propertySpecs.priceRange
    ) {
      setFormData((prevData) => ({
        ...formData,
        BHK: [...prevData.BHK, propertySpecs.BHK],
        sqftMin: [...prevData.sqftMin, propertySpecs.sqftMin],
        sqftMax: [...prevData.sqftMax, propertySpecs.sqftMax],
        priceRange: [...prevData.priceRange, propertySpecs.priceRange],
      }));

      // Reset form inputs after submission
      setpropertySpecs({
        BHK: "",
        sqftMin: "",
        sqftMax: "",
        priceRange: "",
      });
    } else {
      alert("Please fill in all the fields.");
    }
  };

  // handle BHK specks delete
  const handleDeletePropertySpecs = (index) => {
    setFormData((prevData) => {
      const updatedFormData = {
        ...prevData,
        BHK: prevData.BHK.filter((_, i) => i !== index),
        sqftMin: prevData.sqftMin.filter((_, i) => i !== index),
        sqftMax: prevData.sqftMax.filter((_, i) => i !== index),
        priceRange: prevData.priceRange.filter((_, i) => i !== index),
      };

      return updatedFormData;
    });
  };

  // submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.price <= 0) return setError("Change the price");
    if (formData.imageUrls.length <= 0) return setError("Upload image");

    if (formData.reraimageURLS.length <= 0)
      return setError("Upload rera image");

    const dataToSubmit = {
      ...formData,
      location: regionMode, // Add this line
      propertytype:
        propertyType === "commercial"
          ? "commercial"
          : "residential" || "residential",
    };

    try {
      setLoading(true);
      setError(false);

      const propertyDataRes = await apiClient.post(
        `listing/update/${params.listingId}`,
        dataToSubmit,
      );

      setLoading(false);
      if (propertyDataRes.success === false) {
        setError(propertyDataRes.message);
      }

      if (propertyDataRes.status === 200) {
        navigate("/profile");
      }

      //   console.log(propertyDataRes);
    } catch (error) {
      setError(error.message);
      setLoading(false);
      console.log(error.message);
    }
  };

  // delete Property
  const handleDeleteProperty = async (listingId, index) => {
    try {
      if (
        formData.imageUrls.length <= 0 &&
        formData.reraimageURLS.length <= 0
      ) {
        const deleteProperty = await apiClient.delete(
          `listing/delete/${listingId}`,
        );
        const data = deleteProperty.data;
        navigate("/profile");
        if (data.success === false) {
          console.log(data.message);
          return;
        }
        // console.log(deleteProperty);
      } else {
        alert("Delete All Images First!");
        return;
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Location Wise Differentiation
  const [propertyType, setPropertyType] = useState("");
  const [regionMode, setRegionMode] = useState("");

  const mumbaiRegions = [
    "Western Suburbs",
    "Eastern Suburbs",
    "Churchgate",
    "South Bombay",
    "Navi Mumbai",
    "Kalyan Dombivli",
    "Ambernath Badlapur",
    "Vasai Virar Naigaon",
    "Thane",
    "Palghar",
  ];

  const puneRegions = [
    "Pimpri Chinchwad",
    "Pune West",
    "Pune South",
    "Pune East",
    "Pune Center",
  ];

  const mumbaiSubregions = [
    "Andheri",
    "Asangaon",
    "Ambivali",
    "Bhiwandi",
    "Byculla",
    "Belapur",
    "Bhayandar",
    "Bandra",
    "Charni Road",
    "Chandivali",
    "Dahanu Road",
    "Vangaon",
    "Umroli",
    "Kelve",
    "Ram Mandir",
    "Goregaon",
    "Malad",
    "Borivali",
    "Dahisar",
    "Mira Road",
    "Chembur Wadala",
    "Mulund",
    "Mahim",
    "Vikroli",
    "Bhandup",
    "kanjurmarg",
    "Koparkhairane",
    "Kurla",
    "Ghatkopar",
    "Grant Road",
    "South Bombay",
    "Airoli",
    "Ghansoli",
    "Govandi",
    "Juinagar Nerul Sanpada",
    "Juhu",
    "Jogeshwari",
    "Sanpada",
    "Pushpak Nagar",
    "Vashi",
    "Kharghar",
    "Lower Parel",
    "Taloja",
    "Seawoods",
    "Panvel",
    "Rasayani",
    "Ulwe",
    "Kalyan",
    "Kalwa",
    "Shilphata",
    "Dombivali",
    "Worli",
    "Wadala",
    "Sion",
    "Matunga",
    "Marine Lines",
    "Malabar Hill",
    "Mazgaon",
    "Dadar",
    "Shahad",
    "Ambernath",
    "Badlapur",
    "Powai",
    "Santacruz",
    "Sewri",
    "Saphale",
    "Turbhe",
    "Dahisar Mira Road",
    "Nahur",
    "Kalamboli",
    "Titwala",
    "Neral",
    "Vithalwadi",
    "Versova",
    "Ulhasnagar",
    "Karjat",
    "Khopoli",
    "Vasai",
    "Vidhyavihar",
    "Vadghar",
    "Versova",
    "Vile Parle",
    "Virar",
    "Naigaon",
    "Palghar",
    "Boisar",
    "Thane",
    "Tardeo",
    "Thakurli",
    "Chembur",
    "Vadala",
    "Kandivali",
    "Mumbai Central",
    "Mumbra",
    "Mahalaxmi",
    "Nalasopara",
    "Diva",
    "Parel",
  ];

  const puneSubregions = [
    "Moshi",
    "Bhugaon",
    "Bibwewadi",
    "Talegaon Dabhade",
    "Bhukum",
    "Charholi Budruk",
    "Chikhali",
    "Alandi",
    "Chakan",
    "Bhosari",
    "Chinchwad",
    "Dehu",
    "Dhankawadi",
    "Handewadi",
    "Lonikand",
    "Phursungi",
    "Pune",
    "Pimpri",
    "Pimpri Nilakh",
    "Nigdi",
    "Baner",
    "Ravet",
    "Sangamvadi",
    "Hinjawadi",
    "Tathawade",
    "Bavdhan",
    "Wakad",
    "Wanowrie",
    "Punawale",
    "Balewadi",
    "Pirangut",
    "Mahalunge",
    "Kiwale",
    "Rahatani",
    "Mohammed Wadi",
    "Ambegaon BK",
    "Kondhwa Budruk",
    "Kondhwa",
    "Parvati",
    "Pashan",
    "Katraj",
    "Dhayari",
    "Undri",
    "Hadapsar",
    "Saswad",
    "Wagholi",
    "Kharadi",
    "Lohegaon",
    "Dhanori",
    "Mundhwa",
    "Manjri",
    "Mamurdi",
    "Wadgaon Sheri",
    "Keshav Nagar",
    "Viman Nagar",
    "Kesnand",
    "Kothrud",
    "Shivaji Nagar",
    "Sus",
    "Erandwane",
    "Sadashiv Peth",
    "Gultekdi",
    "Deccan",
    "Kasba Peth",
    "Karve Nagar",
    "Dattawadi",
    "Nana Peth",
    "NIBM",
  ];

  return (
    <>
      <section className="create-listing-section">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="sign-up-div">
                <h1 className="sign-up-txt mt-3">Update Property</h1>
                <div style={{ marginBottom: "10px" }}>
                  <button
                    type="button"
                    onClick={() => setRegionMode("mumbai")}
                    style={{
                      backgroundColor:
                        regionMode === "mumbai" ? "#032B5F" : "#fff",
                      color: regionMode === "mumbai" ? "#fff" : "#032B5F",
                      border: "1px solid #032B5F",
                      borderRadius: "20px",
                      padding: "8px 24px",
                      marginRight: "10px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Mumbai
                  </button>
                  <button
                    type="button"
                    onClick={() => setRegionMode("pune")}
                    style={{
                      backgroundColor:
                        regionMode === "pune" ? "#032B5F" : "#fff",
                      color: regionMode === "pune" ? "#fff" : "#032B5F",
                      border: "1px solid #032B5F",
                      borderRadius: "20px",
                      padding: "8px 24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Pune
                  </button>
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <button
                    type="button"
                    onClick={() => setPropertyType("residential")}
                    style={{
                      backgroundColor:
                        propertyType === "residential" ? "#032B5F" : "#fff",
                      color:
                        propertyType === "residential" ? "#fff" : "#032B5F",
                      border: "1px solid #032B5F",
                      borderRadius: "20px",
                      padding: "8px 24px",
                      marginRight: "10px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Residential
                  </button>
                  <button
                    type="button"
                    onClick={() => setPropertyType("commercial")}
                    style={{
                      backgroundColor:
                        propertyType === "commercial" ? "#032B5F" : "#fff",
                      color: propertyType === "commercial" ? "#fff" : "#032B5F",
                      border: "1px solid #032B5F",
                      borderRadius: "20px",
                      padding: "8px 24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Commercial
                  </button>

                  {/* <button
                    type="button"
                    onClick={() => setPropertyType("residential commercial")}
                    style={{
                      backgroundColor:
                        propertyType === "residential commercial"
                          ? "#032B5F"
                          : "#fff",
                      color:
                        propertyType === "residential commercial"
                          ? "#fff"
                          : "#032B5F",
                      border: "1px solid #032B5F",
                      borderRadius: "20px",
                      padding: "8px 24px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Residential / Commercial
                  </button> */}
                </div>
                <form onSubmit={handleSubmit} className="listingForm">
                  <input
                    type="text"
                    placeholder="Property Name"
                    className="listing-input"
                    id="propertyName"
                    name="name"
                    maxLength="62"
                    minLength="2"
                    required
                    onChange={handleChange}
                    value={formData.name}
                  />
                  <textarea
                    type="text"
                    placeholder="Property Overview"
                    className="listing-input"
                    id="propertyDesc"
                    name="description"
                    required
                    onChange={handleChange}
                    value={formData.description}
                  />
                  <input
                    type="text"
                    placeholder="Property Price"
                    className="listing-input"
                    id="propertyPrice"
                    required
                    name="price"
                    onChange={handleChange}
                    value={formData.price}
                  />
                  <input
                    type="text"
                    placeholder="Possession Date"
                    className="listing-input"
                    id="propertyPossessionDate"
                    required
                    name="possessiondate"
                    onChange={handleChange}
                    value={formData.possessiondate}
                  />
                  <input
                    type="text"
                    placeholder="Developer Name"
                    className="listing-input"
                    id="propertyDeveloperName"
                    required
                    name="devlopername"
                    onChange={handleChange}
                    value={formData.devlopername}
                  />
                  <input
                    type="text"
                    placeholder="Property Address"
                    className="listing-input"
                    id="propertyAddress"
                    required
                    name="address"
                    onChange={handleChange}
                    value={formData.address}
                  />
                  <textarea
                    type="text"
                    placeholder="About Developer"
                    className="listing-input"
                    id="propertyDeveloperDesc"
                    required
                    name="aboutdevloper"
                    onChange={handleChange}
                    value={formData.aboutdevloper}
                  />
                  <Editor
                    apiKey="tt08amtyiz5bzwzu9xzh9n8qvlbjg6obld2q7xjftgdszlrk"
                    init={{
                      height: 500,
                      menubar: true,
                      plugins: "link lists image table code",
                      toolbar:
                        "undo redo | formatselect | bold italic | alignleft aligncenter alignright | " +
                        "h2 h3 | bullist numlist | " +
                        "code",
                    }}
                    value={formData.extraDetails}
                    onEditorChange={(newValue) =>
                      setFormData({ ...formData, extraDetails: newValue })
                    }
                  />
                  {/* Multiple Checkboxes for Amenities */}
                  <label className="text-start">
                    <b>Amenities:</b>
                  </label>
                  {propertyType === "residential" && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "50px",
                        marginTop: "5px",
                      }}
                    >
                      {/* Flexbox for inline display */}
                      <label>
                        <input
                          type="checkbox"
                          value="Clubhouse"
                          name="amenities"
                          checked={formData.amenities.includes("Clubhouse")}
                          onChange={handleChange}
                        />
                        Clubhouse
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Swimming Pool"
                          name="amenities"
                          checked={formData.amenities.includes("Swimming Pool")}
                          onChange={handleChange}
                        />
                        Swimming Pool
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Gym"
                          name="amenities"
                          checked={formData.amenities.includes("Gym")}
                          onChange={handleChange}
                        />
                        Gym
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Jogging Track"
                          name="amenities"
                          checked={formData.amenities.includes("Jogging Track")}
                          onChange={handleChange}
                        />
                        Jogging Track
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Yoga"
                          checked={formData.amenities.includes("Yoga")}
                          onChange={handleChange}
                        />
                        Yoga
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Electric Vehicle Charging"
                          checked={formData.amenities.includes(
                            "Electric Vehicle Charging",
                          )}
                          onChange={handleChange}
                        />
                        Electric Vehicle Charging
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Coworking spaces"
                          checked={formData.amenities.includes(
                            "Coworking spaces",
                          )}
                          onChange={handleChange}
                        />
                        Coworking spaces
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Kids Play Area"
                          checked={formData.amenities.includes(
                            "Kids Play Area",
                          )}
                          onChange={handleChange}
                        />
                        Kids Play Area
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Basket Ball Court"
                          checked={formData.amenities.includes(
                            "Basket Ball Court",
                          )}
                          onChange={handleChange}
                        />
                        Basket Ball Court
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Turf"
                          checked={formData.amenities.includes("Turf")}
                          onChange={handleChange}
                        />
                        Turf
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Spa"
                          checked={formData.amenities.includes("Spa")}
                          onChange={handleChange}
                        />
                        Spa
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="CCTV Camera"
                          checked={formData.amenities.includes("CCTV Camera")}
                          onChange={handleChange}
                        />
                        CCTV Camera
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Cricket Turf"
                          checked={formData.amenities.includes("Cricket Turf")}
                          onChange={handleChange}
                        />
                        Cricket Turf
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Amphitheatre"
                          name="amenities"
                          checked={formData.amenities.includes("Amphitheatre")}
                          onChange={handleChange}
                        />
                        Amphitheatre
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Lawn tennis courts"
                          checked={formData.amenities.includes(
                            "Lawn tennis courts",
                          )}
                          onChange={handleChange}
                        />
                        Lawn tennis courts
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Multipurpose halls"
                          checked={formData.amenities.includes(
                            "Multipurpose halls",
                          )}
                          onChange={handleChange}
                        />
                        Multipurpose halls
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Banquet halls"
                          name="amenities"
                          checked={formData.amenities.includes("Banquet halls")}
                          onChange={handleChange}
                        />
                        Banquet halls
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Temple"
                          name="amenities"
                          checked={formData.amenities.includes("Temple")}
                          onChange={handleChange}
                        />
                        Temple
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          name="amenities"
                          value="Masjid"
                          checked={formData.amenities.includes("Masjid")}
                          onChange={handleChange}
                        />
                        Masjid
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Indoor Games"
                          name="amenities"
                          checked={formData.amenities.includes("Indoor Games")}
                          onChange={handleChange}
                        />
                        Indoor Games
                      </label>
                    </div>
                  )}
                  {propertyType === "commercial" && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "50px",
                        marginTop: "5px",
                      }}
                    >
                      {/* Flexbox for inline display */}
                      <label>
                        <input
                          type="checkbox"
                          value="Elevators"
                          name="amenities"
                          checked={formData.amenities.includes("Elevators")}
                          onChange={handleChange}
                        />
                        Elevators
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Escalator"
                          name="amenities"
                          checked={formData.amenities.includes("Escalator")}
                          onChange={handleChange}
                        />
                        Escalator
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Water Supply"
                          name="amenities"
                          checked={formData.amenities.includes("Water Supply")}
                          onChange={handleChange}
                        />
                        Water Supply
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Parking"
                          name="amenities"
                          checked={formData.amenities.includes("Parking")}
                          onChange={handleChange}
                        />
                        Parking
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Conference Room"
                          name="amenities"
                          checked={formData.amenities.includes(
                            "Conference Room",
                          )}
                          onChange={handleChange}
                        />
                        Conference Room
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="CCTV"
                          name="amenities"
                          checked={formData.amenities.includes("CCTV")}
                          onChange={handleChange}
                        />
                        CCTV
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Fire Safety"
                          name="amenities"
                          checked={formData.amenities.includes("Fire Safety")}
                          onChange={handleChange}
                        />
                        Fire Safety
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          value="Comfort And Wellness"
                          name="amenities"
                          checked={formData.amenities.includes(
                            "Comfort And Wellness",
                          )}
                          onChange={handleChange}
                        />
                        Comfort And Wellness
                      </label>
                    </div>
                  )}
                  <br />

                  {/*  end amenities */}

                  <p className="offer-valid-txt">Discounted Deal</p>
                  <div className="discounted-deal-form-update-div">
                    <div>
                      <input
                        type="radio"
                        id="trueDiscount"
                        name="discount"
                        className="listing-input"
                        value="true"
                        required
                        onChange={handleChange}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        id="falseDiscount"
                        type="radio"
                        name="discount"
                        className="listing-input"
                        value="false"
                        required
                        onChange={handleChange}
                      />
                      No
                    </div>
                  </div>

                  {/* Main Region  */}
                  <select
                    required
                    onChange={handleChange}
                    name="region"
                    value={formData.region}
                    className="listing-input"
                    id="regionName"
                  >
                    <option value="" disabled hidden>
                      Select Region
                    </option>
                    {(regionMode === "mumbai"
                      ? mumbaiRegions
                      : puneRegions
                    ).map((region) => (
                      <option key={region} value={region}>
                        {region}
                      </option>
                    ))}
                  </select>

                  {/* <select
                    required
                    onChange={handleChange}
                    value={formData.region}
                    className="listing-input"
                    name=""
                    id="regionName"
                  >
                    <option value="" disabled hidden>
                      Select Region
                    </option>
                    <option value="Western Suburbs">{formData.region}</option>
                    <option value="Western Suburbs">Western Suburbs</option>
                    <option value="Eastern Suburbs">Eastern Suburbs</option>
                    <option value="South Bombay">South Bombay</option>
                    <option value="Navi Mumbai">Navi Mumbai</option>
                    <option value="Kalyan Dombivli">Kalyan Dombivli</option>
                    <option value="Ambernath Badlapur">
                      Ambernath Badlapur
                    </option>
                    <option value="Vasai Virar Naigaon">
                      Vasai Virar Naigaon
                    </option>
                    <option value="Chembur & Wadala">Chembur & Wadala</option>
                    <option value="Thane">Thane</option>
                  </select> */}

                  {/* Sub region  */}
                  {/* <select
                    required
                    onChange={handleChange}
                    value={formData.subregion}
                    className="listing-input"
                    name=""
                    id="subregionName"
                  >
                    <option value="" disabled hidden>
                      Select Sub Region
                    </option>
                    <option value="Andheri">Andheri</option>
                    <option value="Goregaon">Goregaon</option>
                    <option value="Malad">Malad</option>
                    <option value="Borivali">Borivali</option>
                    <option value="Kalyan Dombivli">Kalyan Dombivli</option>
                    <option value="Dahisar">Dahisar</option>
                    <option value="Mira Road">Mira Road</option>
                    <option value="Chembur Wadala">Chembur Wadala</option>
                    <option value="Mulund">Mulund</option>
                    <option value="Vikroli">Vikroli</option>
                    <option value="Bhandup">Bhandup</option>
                    <option value="kanjurmarg">kanjurmarg</option>
                    <option value="Kurla">Kurla</option>
                    <option value="Ghatkoper">Ghatkoper</option>
                    <option value="South Bombay">South Bombay</option>
                    <option value="Airoli Ghansoli">Airoli Ghansoli</option>
                    <option value="Juinager Nerul Sanpada">
                      Juinager Nerul Sanpada
                    </option>
                    <option value="Vashi">Vashi</option>
                    <option value="Kharghar">Kharghar</option>
                    <option value="Taloja">Taloja</option>
                    <option value="Seawoods">Seawoods</option>
                    <option value="Panvel">Panvel</option>
                    <option value="Ulwe">Ulwe</option>
                    <option value="Kalyan">Kalyan</option>
                    <option value="Dombivali">Dombivali</option>
                    <option value="Worli">Worli</option>
                    <option value="Dadar">Dadar</option>
                    <option value="Wadala Sion">Wadala Sion</option>
                    <option value="Shahad">Shahad</option>
                    <option value="Ambernath">Ambernath</option>
                    <option value="Badlapur">Badlapur</option>
                    <option value="Titwala">Titwala</option>
                    <option value="Neral">Neral</option>
                    <option value="Karjat">Karjat</option>
                    <option value="Khopoli">Khopoli</option>
                    <option value="Vasai">Vasai</option>
                    <option value="Virar">Virar</option>
                    <option value="Naigaon">Naigaon</option>
                    <option value="Palghar">Palghar</option>
                    <option value="Boisar">Boisar</option>
                    <option value="Thane">Thane</option>
                    <option value="Chembur">Chembur</option>
                    <option value="Vadala">Vadala</option>
                  </select> */}

                  <select
                    required
                    onChange={handleChange}
                    name="subregion"
                    value={formData.subregion}
                    className="listing-input"
                    id="subregionName"
                  >
                    <option value="" disabled hidden>
                      Select Sub Region
                    </option>
                    {(regionMode === "mumbai"
                      ? mumbaiSubregions
                      : puneSubregions
                    ).map((subregion) => (
                      <option key={subregion} value={subregion}>
                        {subregion}
                      </option>
                    ))}
                  </select>
                  <div className="file-input-div">
                    <input
                      type="text"
                      placeholder="BHK"
                      className="listing-input"
                      name="BHK"
                      value={propertySpecs.BHK}
                      onChange={handlePropertySpecsChange}
                    />
                    <input
                      type="text"
                      placeholder="sqft Min"
                      className="listing-input"
                      name="sqftMin"
                      value={propertySpecs.sqftMin}
                      onChange={handlePropertySpecsChange}
                    />
                    <input
                      type="text"
                      placeholder="sqft Max"
                      className="listing-input"
                      name="sqftMax"
                      value={propertySpecs.sqftMax}
                      onChange={handlePropertySpecsChange}
                    />
                    <input
                      type="text"
                      placeholder="90 Lakhs"
                      className="listing-input"
                      name="priceRange"
                      value={propertySpecs.priceRange}
                      onChange={handlePropertySpecsChange}
                    />
                    <button
                      type="button"
                      onClick={handleSubmitPropertySpecs}
                      className="upload-btn"
                    >
                      Add
                    </button>
                  </div>
                  <table border="1" cellPadding="5" cellSpacing="0">
                    <thead>
                      <tr>
                        <th>BHK</th>
                        <th>Sqft Min</th>
                        <th>Sqft Max</th>
                        <th>Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.BHK.map((_, index) => (
                        <tr key={index}>
                          <td>{formData.BHK[index]}</td>
                          <td>{formData.sqftMin[index]}</td>
                          <td>{formData.sqftMax[index]}</td>
                          <td>{formData.priceRange[index]}</td>
                          <td>
                            <button
                              className="delete-btn"
                              onClick={() => handleDeletePropertySpecs(index)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    Images:{" "}
                    <span>The first image will be the desktop image</span>
                  </p>
                  <div className="file-input-div">
                    <input
                      onChange={(e) => setPropertyFiles(e.target.files)}
                      type="file"
                      accept="images/*"
                      multiple
                      placeholder="Property Images"
                      className="listing-input"
                      id="propertyImages"
                    />
                    <button
                      type="button"
                      onClick={handleImageSubmit}
                      className="upload-btn"
                    >
                      {uploading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                  <p className="error-image-upload">
                    {imageUploadError && imageUploadError}
                  </p>
                  <div className="listing-image-div">
                    {formData.imageUrls.length > 0 &&
                      formData.imageUrls.map((url, index) => (
                        <>
                          <img
                            key={url}
                            src={url}
                            className="listing-image"
                            alt=""
                          />
                          <button
                            onClick={() => handleRemoveIamge(index)}
                            type="button"
                            className="delete-btn"
                          >
                            Delete
                          </button>
                        </>
                      ))}
                  </div>

                  {/* Scanner form  */}
                  <p>Rera Scanner Images</p>
                  <div className="file-input-div">
                    <input
                      onChange={(e) => setReraFiles(e.target.files)}
                      type="file"
                      accept="images/*"
                      multiple
                      placeholder="Property Images"
                      className="listing-input"
                      id="propertyImages"
                    />
                    <button
                      type="button"
                      onClick={handlereraImageSubmit}
                      className="upload-btn"
                    >
                      {rerauploading ? "Uploading..." : "Upload"}
                    </button>
                  </div>
                  <div className="listing-image-div">
                    {formData.reraimageURLS.length > 0 &&
                      formData.reraimageURLS.map((url, index) => (
                        <>
                          <img
                            key={url}
                            src={url}
                            className="listing-image"
                            alt=""
                          />
                          <button
                            onClick={() => handleRemoveReraIamge(index)}
                            type="button"
                            className="delete-btn"
                          >
                            Delete
                          </button>
                        </>
                      ))}
                  </div>
                  <p className="error-image-upload">
                    {imageUploadError && imageUploadError}
                  </p>
                  <input
                    type="text"
                    placeholder="Rera Number"
                    className="listing-input"
                    id="propertyReraName"
                    maxLength="62"
                    required
                    onChange={handleChange}
                    value={formData.reraName}
                  />

                  {/* Scanner form  */}

                  <div className="create-listing-btn-div">
                    <button
                      disabled={loading || uploading}
                      className="create-property-btn"
                    >
                      {loading ? "Updating..." : "Update Property"}
                    </button>

                    <button
                      onClick={() => handleDeleteProperty(formData._id)}
                      className="btn-delete"
                    >
                      Delete Property
                    </button>
                  </div>
                  <div className="create-listing-btn-div">
                    {error && <p className="text-danger">{error}</p>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateListing;
